import { ActionType, createAction } from 'typesafe-actions';
import { IYandexAddressObject } from 'api/geocoder-yandex';
import {
    IObjectSearchResult,
    SearchType,
    ISearchReducerState
} from './search-reducer';

export const searchActions = {
    setSearchInputValue: createAction('SET_SEARCH_INPUT_VALUE')<string>(),
    setOmsSearchResults: createAction('SET_OMS_SEARCH_RESULTS')<ISearchReducerState['objects_search_result']>(),
    setSearchType: createAction('SET_SEARCH_TYPE')<SearchType>(),
    clearState: createAction('SEARCH_CLEAR_STATE')()
};

export type TSearchActions = ActionType<typeof searchActions>;
